import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithLogout } from "@/lib/baseQuery";
import {
  DashboardBaseParams,
  KPIResponse,
  TimeAnalyticsResponse,
  MenuPerformanceResponse,
  CustomerEngagementResponse,
} from "./dashboard.type";

export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery: baseQueryWithLogout,
  tagTypes: ["Dashboard"],
  endpoints: (builder) => ({
    // Get KPI metrics
    getKPIs: builder.query<KPIResponse, DashboardBaseParams>({
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      query: ({ restaurant_id, ...params }) => ({
        url: "/dashboard/kpis",
        method: "GET",
        params,
      }),
      providesTags: ["Dashboard"],
    }),

    // Get time analytics
    getTimeAnalytics: builder.query<TimeAnalyticsResponse, DashboardBaseParams>({
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      query: ({ restaurant_id, ...params }) => ({
        url: "/dashboard/time_analytics",
        method: "GET",
        params,
      }),
      providesTags: ["Dashboard"],
    }),

    // Get menu performances
    getMenuPerformances: builder.query<MenuPerformanceResponse, DashboardBaseParams>({
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      query: ({ restaurant_id, ...params }) => ({
        url: "/dashboard/menu_performances",
        method: "GET",
        params,
      }),
      providesTags: ["Dashboard"],
    }),

    // Get customer engagement
    getCustomerEngagement: builder.query<CustomerEngagementResponse, DashboardBaseParams>({
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      query: ({ restaurant_id, ...params }) => ({
        url: "/dashboard/customer_engagement",
        method: "GET",
        params,
      }),
      providesTags: ["Dashboard"],
    }),
  }),
});

export const {
  useGetKPIsQuery,
  useGetTimeAnalyticsQuery,
  useGetMenuPerformancesQuery,
  useGetCustomerEngagementQuery,
} = dashboardApi;